module.exports = __webpack_public_path__ + "img/28_fineStaff_twb.89a0fa42.png";